<script setup>
import { onMounted, watch } from "vue";
import { XCircle } from "lucide-vue-next";
import AppHeader from "@/components/layout/AppHeader.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import LoginPanel from "@/components/common/LoginPanel.vue";
import { useAuthStore } from "@/stores/auth";
import { useSettingsStore } from "@/stores/settings";
import UploadStatusCard from "@/features/settings/components/UploadStatusCard.vue";
import UploadTokenCard from "@/features/settings/components/UploadTokenCard.vue";
import AutomationGuidePanel from "@/features/settings/components/AutomationGuidePanel.vue";

const auth = useAuthStore();
const settings = useSettingsStore();

onMounted(async () => {
  await auth.loadAuth();
  if (auth.user) settings.loadSettings();
});

watch(
  () => auth.user?.id,
  () => {
    if (auth.user) settings.loadSettings();
  }
);
</script>

<template>
  <main class="app-shell">
    <AppHeader login-redirect="/tokenomics/settings" />

    <section class="page-hero">
      <div class="container">
        <h1>设置</h1>
        <p>你的上传状态、设备上传 token 和 mac app 自动上传流程。</p>
      </div>
    </section>

    <section class="settings-body">
      <div class="container settings-stack">
        <div v-if="!auth.loaded" class="loading-line">正在检查登录态...</div>
        <LoginPanel v-else-if="!auth.user" redirect="/tokenomics/settings" />
        <template v-else>
          <div v-if="settings.error" class="alert">
            <XCircle :size="16" />
            {{ settings.error }}
          </div>
          <div v-if="settings.loading" class="loading-line">正在加载设置...</div>
          <template v-else>
            <div class="settings-grid">
              <UploadStatusCard :my-usage="settings.todayUsage" />
              <UploadTokenCard
                :active-legacy-tokens="settings.activeLegacyTokens"
                :tokens="settings.tokens"
                @revoke="settings.revokeUploadToken"
              />
            </div>
            <AutomationGuidePanel />
          </template>
        </template>
      </div>
    </section>

    <AppFooter />
  </main>
</template>
